import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import PublishIcon from '@material-ui/icons/Publish';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import FileUploader from '../../AddAnomaly/FileUploader/FileUploader';
import ApiService from '../../../services/ApiService';
import ImportationFailedPopUp from './ImportationFailedPopUp';
import ImportationSucceededPopUp from './ImportationSucceededPopUp';
import helpers from '../../AddAnomaly/FileUploader/Helpers';

const FileSaver = require('file-saver');

export default function ImportInvoiceFromExcelPopUp(props) {
  const {
    openImportInvoiceFromExcelPopUp,
    supplier,
    activityType,
    invoiceNumber,
    invoiceDate,
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const [sendClicked, setSendClicked] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [attachment, setAttachment] = React.useState({});
  const [validationErrors, setValidationErrors] = React.useState([]);

  const [openImportationSucceededPopUp, setOpenImportationSucceededPopUp] =
    React.useState(false);
  const [openImportationFailedPopUp, setOpenImportationFailedPopUp] =
    React.useState(false);

  function closeImportInvoiceFromExcelPopUp() {
    props.closeImportInvoicePopUp(false);
  }

  function createFormData() {
    const data = new FormData();
    const invoiceDTO = {
      supplier,
      activityType,
      invoiceNumber,
      invoiceDate,
    };
    data.append(
      'invoice',
      new Blob([JSON.stringify(invoiceDTO)], {
        type: 'application/json',
      }),
    );
    data.append('file', attachment);
    return data;
  }

  function confirmImport() {
    setSendClicked(true);
    setLoading(true);

    const invoiceWithExcel = createFormData();

    ApiService.importInvoicesFromExcel(invoiceWithExcel)
      .then((response) => {
        const wagonsNotAvailable = response.data.filter(
          (invoiceObj) => invoiceObj.wagonError === true,
        );
        if (wagonsNotAvailable.length === 0) {
          const invoices = response.data.map((invoice) => {
            return { ...invoice, eventDate: new Date(invoice.eventDate) };
          });
          props.setInvoicesFromExcel(invoices);
          props.sendFile(attachment);
          setLoading(false);
          setOpenImportationSucceededPopUp(true);
          props.closeImportInvoicePopUp();
        } else {
          const wagonErrorList = wagonsNotAvailable
            .map((wagonItem) => wagonItem.wagonNumber)
            .join(', ');
          props.closeImportInvoicePopUp();
          setLoading(false);
          setOpenImportationFailedPopUp(true);
          setValidationErrors({ wagonError: wagonErrorList });
        }
      })
      .catch((error) => {
        if (error) {
          props.sendValidationErrors(error.formValidationErrors);
          if (
            JSON.stringify(error.excelValidationErrors) !== JSON.stringify({})
          ) {
            setOpenImportationFailedPopUp(true);
            setValidationErrors(error.excelValidationErrors);
          }
        }
        props.closeImportInvoicePopUp();
        setLoading(false);
      });
  }
  function closeImportationFailedPopUp() {
    setOpenImportationFailedPopUp(false);
  }
  function closeImportationSucceededPopUp() {
    setOpenImportationSucceededPopUp(false);
  }

  function getAttachment(file) {
    setAttachment(file[0]);
  }
  function downloadInvoiceTemplate() {
    setLoading(true);

    ApiService.downloadInvoiceTemplate()
      .then((response) => {
        const blob = new Blob([helpers.base64toBlob(response.data)], {});
        FileSaver.saveAs(blob, 'Invoice_template.xlsx');
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }
  return (
    <div>
      <Dialog
        open={openImportInvoiceFromExcelPopUp}
        onClose={closeImportInvoiceFromExcelPopUp}
        maxWidth="md"
        classes={{ paper: classes.paper }}
      >
        {loading && (
          <Paper elevation={0} position="absolute" zindex="2">
            <CircularProgress className={classes.loader} />
          </Paper>
        )}
        <Grid container spacing={0}>
          <Grid item xs={1}>
            <PublishIcon className={classes.publishIcon} fontSize="large" />
          </Grid>
          <Grid item xs={11}>
            <DialogTitle className={classes.dialogTitle}>
              <Box display="flex" alignItems="center">
                <Box flexGrow={1}>
                  <Typography className={classes.title}>
                    {t('invoices importation')}
                  </Typography>
                </Box>
                <Box>
                  <IconButton
                    data-testid="close"
                    onClick={closeImportInvoiceFromExcelPopUp}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Box>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
              <DialogContentText className={classes.dialogText}>
                {t('invoices importation message')}
              </DialogContentText>
              <Button
                data-testid="download"
                className={classes.invoiceTemplateButton}
                onClick={downloadInvoiceTemplate}
              >
                Invoice_template.xlsx
              </Button>
              <div className={classes.fileUploaderContent}>
                <FileUploader
                  isInvoicePopUp
                  files={[]}
                  sendAttachmentWithFiles={getAttachment}
                  saveClicked={sendClicked}
                />
              </div>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button
                data-testid="cancel"
                className={classes.cancelButton}
                onClick={closeImportInvoiceFromExcelPopUp}
                variant="outlined"
              >
                {t('Cancel')}
              </Button>
              <Button
                data-testid="validate"
                className={classes.validateButton}
                onClick={confirmImport}
                variant="contained"
                autoFocus
              >
                {t('Validate')}
              </Button>
            </DialogActions>
          </Grid>
        </Grid>
      </Dialog>
      <ImportationFailedPopUp
        openImportationFailedPopUp={openImportationFailedPopUp}
        closeImportationFailedPopUp={closeImportationFailedPopUp}
        validationErrors={validationErrors}
      />
      <ImportationSucceededPopUp
        openImportationSucceededPopUp={openImportationSucceededPopUp}
        closeImportationSucceededPopUp={closeImportationSucceededPopUp}
      />
    </div>
  );
}
